/*
 * @Description: 积分客户记录
 * @Author: guqiang
 * @Date: 2021-09-22 23:55:10
 * @LastEditors: guqiang
 * @LastEditTime: 2021-09-23 00:06:43
 */
import { COINSUM } from '../types';

export default {
    name: `${COINSUM}`,
    path: '/coinSum',
    component: () => import(/* webpackChunkName: 'coinManage' */ '@/views/coinManage/'),
    redirect: { name: `${COINSUM}Index` },
    meta: {
        title: '客户积分概况',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${COINSUM}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'coinManage' */ '@/views/coinManage/home/Sum.vue'),
        },
    ],
};
